<template>
  <div class="trial-expire-risk arrow-box">
    <div class="title">
      您的个人体验会员还有<span class="strong"> {{remainTimeText}} </span>就要到期了。
    </div>
    <div class="content">
      <div class="content-row">
        体验过期后将无法继续免费享用VIP专属素材、无限视频时长、AI智能配音。
      </div>
      <div class="content-row">
        赶紧导出看看视频效果吧~
      </div>
    </div>
    <div class="button-row">
      <div class="btn" @click.stop="confirm">知道了</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
// import '../../assets/vipTrialMessage/'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      remainTimeText: ''
    }
  },
  computed: {
    ...mapGetters([
      'UserMsg'
    ])
  },
  mounted () {
    this.updateRemainTimeRepeatedly();
  },
  beforeDestroy () {
    this.stopRepeat();
  },
  methods: {
    confirm () {
      this.$emit('input', false);
    },
    updateRemainTime () {
      const endTime = this.UserMsg.endDay;
      const remain = Math.max(endTime - Date.now() / 1000, 0);
      if (!remain) {

      }
      const h = Math.floor(remain / 60 / 60) || 0;
      const m = Math.floor(remain / 60 % 60) || 0;
      const s = Math.floor(remain % 60) || 0;
      let text = '';
      text = this.pad(s) + '秒';
      text = this.pad(m) + '分' + text;
      text = this.pad(h) + '时' + text;
      this.remainTimeText = text;
    },
    updateRemainTimeRepeatedly () {
      this.updateRemainTime();
      this.stopRepeat();
      this.tid = setInterval(this.updateRemainTime, 500);
    },
    stopRepeat () {
      clearInterval(this.tid);
    },
    pad (n) {
      let str = n + '';
      if (str.length === 1) {
        str = '0' + str;
      }
      return str;
    }
  }
}
</script>

<style lang="scss" scoped>
.trial-expire-risk {
  width: 500px;
  color: #333;
  background-color: #fff;
  text-align: left;
  width: 392px;
  min-height: 186px;
  background:
    url(../../assets/vipTrialMessage/bg-expire-popover.png) right top/100% 100% no-repeat;
  box-shadow: 0px 2px 12px rgba(0,0,0,0.1600);
  opacity: 1;
  border-radius: 4px;
  .title {
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px;
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
    .strong {
      color: #5778FB;
    }
  }
  .content {
    padding-left: 24px;
    padding-right: 24px;
    font-size: 12px;
    line-height: 1.8;
    color: #666666;
  }
  .button-row {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 17px;
    padding-bottom: 20px;
  }
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 126px;
  height: 38px;
  background: #5778FB;
  opacity: 1;
  border-radius: 4px;
  color: #fff;
  &:hover {
    background-color: #7d95f5;
  }
}

.arrow-box {
	position: relative;
}
.arrow-box:after {
	bottom: 100%;
	right: 28px;
	border: solid transparent;
	content: "";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
	border-color: rgba(136, 183, 213, 0);
	border-bottom-color: #E3D3FC;
	border-width: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/trialExpireRisk.vue